import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  AutocompleteInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
  required,
  usePermissions,
} from 'react-admin';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Toolbar } from '../../../components';
import { getUser } from '../../../user';

const sanitizeRestProps = ({
  hasShow,
  hasEdit,
  hasList,
  hasCreate,
  ...props
}) => {
  return props;
};

const ProviderForm = ({ onCancel, record, ...props }) => {
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js). This form is mounted by
  // Provider/List.js's DrawerCreateEdit, not by a react-admin
  // <Resource edit=/> route, but usePermissions() only needs the AuthContext
  // provided at <Admin> level, so it works the same inside the Drawer.
  const { permissions } = usePermissions();
  const user = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user,
  // 'provider', 'delete', 1)) instead of a hardcoded role test, same motif
  // as Cleaner/detail/Form.js. `isCreate` keeps the button off the Create
  // screen (this Form is shared by Provider/Create.js and Provider/Edit.js,
  // both rendered by the Drawer).
  const isCreate = !record || !record.id;
  const isDeletable = !isCreate && !!(user?.permissions?.provider?.delete >= 1);

  return (
    <Fragment>
      <div style={{ textAlign: 'right' }}>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <SimpleForm
        {...sanitizeRestProps(props)}
        record={record}
        toolbar={<Toolbar isDeletable={isDeletable} />}
      >
        <ReferenceInput
          filterToQuery={(searchText) => {
            return { name: searchText };
          }}
          source="account_id"
          reference="account"
          validate={[required()]}
        >
          <AutocompleteInput
            source="name"
            options={{
              suggestionsContainerProps: {
                /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
                style: { zIndex: 2000 },
              },
            }}
          />
        </ReferenceInput>
        <ReferenceInput
          filterToQuery={(searchText) => {
            return { name: searchText };
          }}
          source="provider"
          reference="account"
          validate={[required()]}
        >
          <AutocompleteInput
            source="name"
            options={{
              suggestionsContainerProps: {
                /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
                style: { zIndex: 2000 },
              },
            }}
          />
        </ReferenceInput>
        <TextInput source="provider_ref_id" validate={[required()]} />
      </SimpleForm>
    </Fragment>
  );
};

ProviderForm.propTypes = {
  classes: PropTypes.object,
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

ProviderForm.defaultProps = {
  classes: {},
  onCancel: /* istanbul ignore next */ () => {},
  record: {},
};

export default ProviderForm;
